<template>
  <app-social-networks />
</template>

<script setup>
import { useStyle } from '@/composables/app/useStyle'

import AppSocialNetworks from '&/molecules/AppSocialNetworks'

const { parent, component } = defineProps({
  parent: { type: Object, required: true },
  component: { type: Object, required: true }
})

const { componentStyle: parentStyle } = useStyle(parent.style)
const { componentStyle: blockStyle } = useStyle(component.style)

const color = blockStyle.value.color || parentStyle.value.color
</script>

<style lang="scss" scoped>
:deep(.link) {
  display: inline-block;
  color: v-bind(color);

  &:hover {
    transform: scale(1.1);
  }
}
</style>
